import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="none"
			>
				{ /* Vertical connector line */ }
				<line
					x1="10" y1="2" x2="10" y2="22"
					stroke="currentColor"
					strokeWidth="1.5"
					opacity=".3"
				/>
				{ /* Top node — content right */ }
				<circle cx="10" cy="4.5" r="2" stroke="currentColor" strokeWidth="1.5" />
				<line x1="14" y1="3.5" x2="21" y2="3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
				<line x1="14" y1="5.5" x2="18" y2="5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".5" />
				{ /* Middle node — content left */ }
				<circle cx="10" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
				<line x1="3" y1="11" x2="6" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
				<line x1="3" y1="13" x2="5" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".5" />
				{ /* Bottom node — content right */ }
				<circle cx="10" cy="19.5" r="2" stroke="currentColor" strokeWidth="1.5" />
				<line x1="14" y1="18.5" x2="21" y2="18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
				<line x1="14" y1="20.5" x2="18" y2="20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity=".5" />
			</svg>
		),
	},
} );
